import React from 'react';
import { Portal } from '../../Configs';
import { portal } from '../../Configs/general';
import ConstructorsGDC from './Constructors.GDC';

const Constructors = () => {
  switch (portal) {
    case Portal.Gascaribe:
      return <ConstructorsGDC />;

    default:
      return <></>;
  }
};

export default Constructors;
